module.exports = __webpack_public_path__ + "img/img8.fce0b324.png";